import React, { useState } from "react";
import { useStyles } from "./styles";
import StatusOverlay from "../StatusOverlay"
import CommunitySolarTabs from "./CommunitySolarTabs";
import ContractReviewQueue from "./ContractReviewQueue";
import LmiApproval from "./LmiApproval";
import NewEnrollments from "./NewEnrollments";
import EnrollmentRejects from "./EnrollmentRejects";

const CommunitySolar = (props) => {
  const classes = useStyles();
  const {
    approvals,
    csEnrollments,
    lmiTypes,
    doFetchGetApprovals,
    doFetchGetDetails,
    approval,
    documents,
    doFetchUpdateMeter,
    doFetchEnrollments,
    doOpenDocument,
    adminUser,
    doFetchMemberEnrollment,
    doRefreshMemberProduct,
    doFetchRequestTdsps,
    doCSMeterBodyUpdate,
  } = props;

  const [selectedView, setSelectedView] = useState("Search Enrollments");
  return (
    <div className={classes.root}>
      <StatusOverlay />
      <h1 id="page-title">
        Community Solar
      </h1>
      <CommunitySolarTabs
        setSelectedView={setSelectedView}
      >
        <ContractReviewQueue
          adminUser={adminUser}
          selectedView={selectedView}
          fetchCSEnrollments={doFetchEnrollments}
          csEnrollments={csEnrollments}
          approval={approval}
          doFetchGetDetails={doFetchGetDetails}
          doFetchMemberEnrollment={doFetchMemberEnrollment}
          doRefreshMemberProduct={doRefreshMemberProduct}
          doFetchRequestTdsps={doFetchRequestTdsps}
          doCSMeterBodyUpdate={doCSMeterBodyUpdate}
        />
        <LmiApproval
          adminUser={adminUser}
          selectedView={selectedView}
          approvals={approvals}
          lmiTypes={lmiTypes}
          doFetchGetApprovals={doFetchGetApprovals}
          doFetchGetDetails={doFetchGetDetails}
          approval={approval}
          documents={documents}
          doFetchUpdateMeter={doFetchUpdateMeter}
          doOpenDocument={doOpenDocument}
        />
        <NewEnrollments
          adminUser={adminUser}
          selectedView={selectedView}
          fetchCSEnrollments={doFetchEnrollments}
          csEnrollments={csEnrollments}
        />
        <EnrollmentRejects
          adminUser={adminUser}
          selectedView={selectedView}
          fetchCSEnrollments={doFetchEnrollments}
          csEnrollments={csEnrollments}
        />
      </CommunitySolarTabs>
    </div>
  );
};

export default CommunitySolar;
